// @flow
import React from 'react';
import { navigate } from '@reach/router';
import { expertiseServiceGpmCostApi } from './../../lib/api';
import CommonListPage from './../../components/hoc/common/handbook/ListPage';
import Page from '../../components/hoc/common/handbook/PageContext';
import { withUserAccess } from './../withUserAccess';

import { Filter } from './components';
import { formatDateTimeToString } from '../../lib/helpers';
import { approveTypes } from '../../lib/enum';
import { getBreadCrumbsByUrl } from '../../lib/autoBreadcrumbs';

const entryPointPath = '/admin/expertise-service-gpm-cost/';

const columns = [
  {
    title: '№ записи',
    dataIndex: 'id'
  },
  {
    title: 'Филиал',
    dataIndex: 'orgUnitName'
  },
  {
    title: 'Дата начала',
    dataIndex: 'startDate',
    render: (startDate: string) =>
      formatDateTimeToString(startDate, 'DD.MM.YYYY')
  },
  {
    title: 'Дата окончания',
    dataIndex: 'endDate',
    render: (endDate: string) => formatDateTimeToString(endDate, 'DD.MM.YYYY')
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    render: status => approveTypes[status]
  }
];

const access = {
  add: () => navigate(`${entryPointPath}new`)
};

export default withUserAccess(({ userAccess }) => {
  const breadCrumbs = getBreadCrumbsByUrl(entryPointPath);

  return (
    <Page>
      <CommonListPage
        crud={expertiseServiceGpmCostApi}
        pageHeaderProps={{
          breadCrumbs,
          mainHeader: 'Стоимость ТО ГПМ и промышленной экспертизы',
          access
        }}
        tableListProps={{
          columns,
          onSelect: (id: number) => navigate(`${entryPointPath}${id}`)
        }}
        filter={Filter}
      />
    </Page>
  );
});
